import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './lib/i18n';
import { AuthProvider } from './lib/auth-php';
import { SiteLayout } from './components/site/SiteLayout';

// Site pages
import { HomePage } from './pages/site/HomePage';
import { ServicesPage } from './pages/site/ServicesPage';
import { ServiceDetailPage } from './pages/site/ServiceDetailPage';
import { AnnouncementsPage } from './pages/site/AnnouncementsPage';
import { AnnouncementDetailPage } from './pages/site/AnnouncementDetailPage';
import { ContactPage } from './pages/site/ContactPage';
import { AboutPage } from './pages/site/AboutPage';

// Auth pages
import LoginPage from './pages/auth/LoginPage';

// Admin pages
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminServices from './pages/admin/AdminServices';
import AdminAnnouncements from './pages/admin/AdminAnnouncements';
import AdminSettings from './pages/admin/AdminSettings';
import AdminUsers from './pages/admin/AdminUsers';

// Protected route component
import { RequireAuth, RequireAdmin } from './lib/auth-php';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/announcements" element={<AnnouncementsPage />} />
            <Route path="/announcements/:id" element={<AnnouncementDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          
          {/* Auth routes */}
          <Route path="/auth/login" element={<LoginPage />} />
          
          {/* Admin routes */}
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="announcements" element={<AdminAnnouncements />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
